import { render, staticRenderFns } from "./HymnbooksApp.vue?vue&type=template&id=b90d1ccc&"
import script from "./HymnbooksApp.vue?vue&type=script&lang=js&"
export * from "./HymnbooksApp.vue?vue&type=script&lang=js&"
import style0 from "./HymnbooksApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports